import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetTargetsDataAction } from "../actions/dataActions";

export const useTargetData = (params, dataFresh) => {
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp("target", "get", params, dataFresh);
  if (error) {
    throw Error("There was an error");
  }

  if (!loading && data !== null) {
    dispatch(createSetTargetsDataAction(data));
  }

  return !loading;
};
